import { useState } from 'react';
import { IconAlert } from '../icons.jsx';

/**
 * Offered once, after a few messages, and dismissible.
 *
 * Whatever is collected here is subject to the org's `leads` retention policy
 * and to the erasure endpoint — which is the difference between collecting a
 * phone number and keeping one forever.
 */
export function LeadForm({ onSubmit, onDismiss }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !phone.trim()) return;
    setBusy(true);
    setError(null);
    try {
      await onSubmit({ name: name.trim(), phone: phone.trim() });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not save your details');
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="lead" onSubmit={submit}>
      <p className="lead-title">Leave your details so we can follow up</p>
      <input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Your name"
        maxLength={120}
        autoComplete="name"
      />
      <input
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        placeholder="Phone number"
        maxLength={32}
        autoComplete="tel"
        inputMode="tel"
      />
      {error && (
        <p className="notice danger" role="alert">
          <IconAlert size={14} />
          {error}
        </p>
      )}
      <div className="lead-actions">
        <button type="button" className="ghost" onClick={onDismiss}>
          Not now
        </button>
        <button type="submit" disabled={busy || !name.trim() || !phone.trim()}>
          {busy ? 'Saving…' : 'Share'}
        </button>
      </div>
    </form>
  );
}
